// src/components/Nav.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./Nav.css";
import logo from "../../../../assets/logo.png"; // Asegúrate de que el path sea correcto
import { MOSTRAR_CALCULAR_HORARIOS } from "../../../../utils/featureFlags";

const Nav = () => (
  <nav style={{ backgroundColor: "#000000" }} className="nav-custom">
    <ul className="nav justify-content-center nav-wrap">
      <li className="nav-item nav-brand">
        <span className="nav-brand-text">Registro</span>
        <img src={logo} alt="Logo" className="nav-logo-img" />
        <span className="nav-brand-text">CCM</span>
      </li>
      {MOSTRAR_CALCULAR_HORARIOS && (
        <li className="nav-item" style={{ display: "flex", alignItems: "center" }}>
          <Link to="/calcular-horarios" style={{ color: "#ffffff" }}>
            Calcular horarios
          </Link>
        </li>
      )}
    </ul>
  </nav>
);

export default Nav;
